import { gql } from "@apollo/client";
import moment from "moment";

export const GET_PACIENTES_PAGINATED = gql`
query GetAllPacientes(
    $skip: Int
    $take: Int
    $where: t_PacienteFilterInput  
    $order : [t_PacienteSortInput!] 
) {
    allPacientes(skip: $skip, take: $take, where: $where, order: $order )
    {
        items {
            idPaciente
            idDelegacion
            mail
            idTipoDocumento
            numeroDocumento
            nombre
            apellido
            fechaNacimiento
            edad
            sexo
            familiar
            familiarTelefono
            vinculo
            informacionAdicional
            fechaAlta
            idUsuario
            fechaEstado
            fechaModificacion
            codSAPPaciente
            edadDesc
            gM
            fechaDesdePaciente
            fechaHastaPaciente
            estadoAPP
            latitud
            longitud
            telefonoUbicacion
            observacionesUbicacion
            sinDoc
            telefonoContacto
        }
        totalCount
    }
}`;

export const adaptPaciente = (paciente) => {
  return {
    idPaciente: paciente.idPaciente,
    idDelegacion: paciente.idDelegacion,
    nameDelegacion: paciente.idDelegacionNavigation?.descripcion,
    mail: paciente.mail,
    idTipoDocumento: paciente.idTipoDocumento,
    numeroDocumento: paciente.numeroDocumento,
    sinDoc: paciente.sinDoc,
    nombre: paciente.nombre,
    apellido: paciente.apellido,
    fechaNacimiento: moment(paciente.fechaNacimiento).format("yyyy-MM-DD"),
    edad: paciente.edad,
    sexo: paciente.sexo,
    familiar: paciente.familiar,
    familiarTelefono: paciente.familiarTelefono,
    vinculo: paciente.vinculo,
    informacionAdicional: paciente.informacionAdicional,
    fechaAlta: paciente.fechaAlta,
    idUsuario: paciente.idUsuario,
    fechaEstado: paciente.fechaEstado,
    fechaModificacion: paciente.fechaModificacion,
    codSAPPaciente: paciente.codSAPPaciente,
    edadDesc: paciente.edadDesc,
    gM: paciente.gM,
    fechaDesdePaciente: paciente.fechaDesdePaciente,
    fechaHastaPaciente: paciente.fechaHastaPaciente,
    estadoAPP: paciente.estadoAPP,
    latitud: paciente.latitud,
    longitud: paciente.longitud,
    telefonoUbicacion: paciente.telefonoUbicacion,
    observacionesUbicacion: paciente.observacionesUbicacion,
    telefonoContacto: paciente.telefonoContacto
  };
};

export const adaptPacientesArray = (
pacientes) =>
{
  return structuredClone(pacientes)?.
  map((paciente) => adaptPaciente(paciente));
};